(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursem-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Accordion toggles
    document.querySelectorAll('.nursem-ingredient-card__toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var desc = btn.nextElementSibling;
        if (desc && desc.classList.contains('nursem-ingredient-card__description')) {
          desc.classList.toggle('nursem-ingredient-card__description--open');
        }
      });
    });

    // Drag-to-scroll on ingredient tracks
    document.querySelectorAll('.nursem-ingredients__track--scrollable').forEach(function(track) {
      var isDown = false;
      var startX;
      var scrollLeft;

      track.addEventListener('mousedown', function(e) {
        isDown = true;
        track.style.cursor = 'grabbing';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        e.preventDefault();
      });

      track.addEventListener('mouseleave', function() {
        isDown = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mouseup', function() {
        isDown = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursem-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      var apiBase = root.dataset.apiBase;
      var storeId = root.dataset.storeId;
      var sku = root.dataset.sku;
      var perPage = parseInt(root.dataset.perPage, 10) || 12;
      var qSkinType = root.dataset.questionSkinType || 'Skin type';
      var qSkinGoal = root.dataset.questionSkinGoal || 'Skin goal';

      var grid = root.querySelector('[data-nursem-reviews-grid]');
      var stateEl = root.querySelector('[data-nursem-reviews-state]');
      var loadMoreBtn = root.querySelector('[data-nursem-reviews-load-more]');
      var searchInput = root.querySelector('[data-nursem-reviews-search]');
      var sortSelect = root.querySelector('[data-nursem-reviews-sort]');
      var filterSkinType = root.querySelector('[data-nursem-reviews-filter="skin_type"]');
      var filterSkinGoal = root.querySelector('[data-nursem-reviews-filter="skin_goal"]');

      if (!storeId || !sku) {
        if (stateEl) stateEl.textContent = 'Reviews configuration missing (store ID or product SKU).';
        return;
      }

      var state = {
        page: 1,
        totalPages: 1,
        filters: { skin_type: '', skin_goal: '' },
        search: '',
        sort: '',
        questionOptions: { skin_type: new Set(), skin_goal: new Set() }
      };

      function escapeHtml(str) {
        if (str == null) return '';
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function starSvg(size) {
        size = size || 16;
        return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="color: var(--nursem-reviews-star, #525E77);"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      }

      function findQuestion(review, title) {
        var arr = review.questions || review.custom_questions || [];
        var lower = title.toLowerCase();
        for (var i = 0; i < arr.length; i++) {
          var q = arr[i];
          var qTitle = (q.title || q.question || '').toLowerCase();
          if (qTitle === lower) {
            return q.answer || q.value || '';
          }
        }
        return '';
      }

      function reviewerName(review) {
        if (review.reviewer) {
          var first = review.reviewer.first_name || '';
          var last = review.reviewer.last_name || '';
          if (first || last) return (first + ' ' + (last ? last.charAt(0) + '.' : '')).trim();
        }
        return review.name || review.author || 'Anonymous';
      }

      function isVerified(review) {
        if (review.reviewer && typeof review.reviewer.verified_buyer !== 'undefined') return !!review.reviewer.verified_buyer;
        return !!review.verified_buyer;
      }

      function buildCard(review) {
        var stars = '';
        var rating = Math.round(review.rating || 0);
        for (var i = 0; i < 5; i++) {
          stars += i < rating ? starSvg(18) : '<span style="opacity:0.2;">' + starSvg(18) + '</span>';
        }
        var skinType = findQuestion(review, qSkinType);
        var skinGoal = findQuestion(review, qSkinGoal);
        if (skinType) state.questionOptions.skin_type.add(skinType);
        if (skinGoal) state.questionOptions.skin_goal.add(skinGoal);

        var reviewBody = (review.review || review.comments || review.text || '').trim();
        var verifiedBadge = isVerified(review)
          ? '<span class="ns-inline-flex ns-items-center ns-gap-1 ns-text-[14px]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--nursem-reviews-accent, #00A895)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>Verified buyer</span>'
          : '';

        return ''
          + '<article class="nursem-reviews__card">'
          +   '<div class="ns-flex ns-items-center ns-gap-0.5 ns-mb-3">' + stars + '</div>'
          +   '<p class="ns-font-body ns-text-[16px] ns-leading-relaxed ns-m-0 ns-whitespace-pre-line">' + escapeHtml(reviewBody) + '</p>'
          +   '<div class="nursem-reviews__card-meta ns-font-body ns-text-[14px]">'
          +     '<div class="ns-flex ns-items-center ns-gap-3 ns-mb-2">'
          +       '<span class="ns-font-heading ns-font-bold">' + escapeHtml(reviewerName(review)) + '</span>'
          +       verifiedBadge
          +     '</div>'
          +     (skinType ? '<div class="ns-mt-1"><strong>Skin type:</strong> ' + escapeHtml(skinType) + '</div>' : '')
          +     (skinGoal ? '<div class="ns-mt-1"><strong>Skin goal:</strong> ' + escapeHtml(skinGoal) + '</div>' : '')
          +   '</div>'
          + '</article>';
      }

      function renderSummary(stats) {
        if (!stats) return;
        var avg = stats.average_rating || stats.average || 0;
        var total = stats.total_reviews || stats.total || 0;
        var avgEl = root.querySelector('[data-nursem-reviews-average]');
        var countEl = root.querySelector('[data-nursem-reviews-count]');
        if (avgEl) avgEl.textContent = Number(avg).toFixed(2);
        if (countEl) countEl.textContent = 'Based on ' + total.toLocaleString() + ' reviews';

        // Distribution bars
        var dist = stats.rating_distribution || stats.distribution || {};
        for (var s = 1; s <= 5; s++) {
          var n = Number(dist[s] || dist[String(s)] || 0);
          var bar = root.querySelector('[data-nursem-reviews-bar="' + s + '"]');
          var countEl2 = root.querySelector('[data-nursem-reviews-count-for="' + s + '"]');
          if (bar) bar.style.width = total > 0 ? ((n / total) * 100).toFixed(1) + '%' : '0%';
          if (countEl2) countEl2.textContent = n.toLocaleString();
        }

        // Recommend %
        var rec = stats.recommend_percentage || stats.recommend || (total > 0 ? Math.round((Number(dist[5] || 0) + Number(dist[4] || 0)) / total * 100) : 0);
        var recEl = root.querySelector('[data-nursem-reviews-recommend]');
        if (recEl) recEl.textContent = Math.round(rec) + '%';
      }

      function renderPhotoStrip(reviews) {
        var strip = root.querySelector('[data-nursem-reviews-photos]');
        if (!strip) return;
        var photos = [];
        reviews.forEach(function(r) {
          var media = r.media || r.photos || [];
          media.forEach(function(m) {
            var url = m.url || m.src || m.thumbnail;
            if (url && photos.length < 6) photos.push(url);
          });
        });
        if (!photos.length) { strip.innerHTML = ''; return; }
        strip.innerHTML = photos.map(function(url) {
          return '<img src="' + escapeHtml(url) + '" alt="Customer photo" loading="lazy" class="ns-w-[88px] ns-h-[88px] ns-rounded-lg ns-object-cover ns-flex-shrink-0">';
        }).join('');
      }

      function updateFilterOptions() {
        [['skin_type', filterSkinType], ['skin_goal', filterSkinGoal]].forEach(function(pair) {
          var key = pair[0];
          var sel = pair[1];
          if (!sel) return;
          var existing = sel.value;
          var values = Array.from(state.questionOptions[key]).sort();
          // Preserve the first "All" option
          sel.innerHTML = '<option value="">' + (key === 'skin_type' ? 'Skin type' : 'Skin goal') + '</option>'
            + values.map(function(v) { return '<option value="' + escapeHtml(v) + '">' + escapeHtml(v) + '</option>'; }).join('');
          sel.value = existing;
        });
      }

      function buildUrl(page) {
        var url = apiBase + '?store=' + encodeURIComponent(storeId) + '&sku=' + encodeURIComponent(sku) + '&page=' + page + '&per_page=' + perPage;
        if (state.sort) url += '&order=' + encodeURIComponent(state.sort);
        if (state.search) url += '&search=' + encodeURIComponent(state.search);
        return url;
      }

      function applyClientFilters(reviews) {
        if (!state.filters.skin_type && !state.filters.skin_goal) return reviews;
        return reviews.filter(function(r) {
          if (state.filters.skin_type && findQuestion(r, qSkinType) !== state.filters.skin_type) return false;
          if (state.filters.skin_goal && findQuestion(r, qSkinGoal) !== state.filters.skin_goal) return false;
          return true;
        });
      }

      function fetchPage(page, append) {
        if (stateEl) { stateEl.textContent = 'Loading reviews…'; stateEl.hidden = false; }
        if (!append && grid) grid.innerHTML = '';

        fetch(buildUrl(page), { headers: { 'Accept': 'application/json' } })
          .then(function(res) {
            if (!res.ok) throw new Error('Failed to load reviews (' + res.status + ')');
            return res.json();
          })
          .then(function(data) {
            var reviews = data.reviews || data.data || [];
            var stats = data.stats || data.statistics || {
              average_rating: data.average_rating,
              total_reviews: data.total_reviews || data.total,
              rating_distribution: data.rating_distribution || data.distribution
            };
            state.totalPages = data.total_pages || data.pages || 1;
            state.page = page;

            if (page === 1) {
              renderSummary(stats);
              renderPhotoStrip(reviews);
            }

            var filtered = applyClientFilters(reviews);
            if (filtered.length === 0 && grid.children.length === 0) {
              stateEl.textContent = 'No reviews match these filters.';
              stateEl.hidden = false;
            } else {
              stateEl.hidden = true;
              filtered.forEach(function(r) {
                grid.insertAdjacentHTML('beforeend', buildCard(r));
              });
              updateFilterOptions();
            }

            // Load more visibility
            if (loadMoreBtn) {
              loadMoreBtn.hidden = state.page >= state.totalPages;
            }
          })
          .catch(function(err) {
            if (stateEl) { stateEl.textContent = err.message || 'Could not load reviews.'; stateEl.hidden = false; }
            if (loadMoreBtn) loadMoreBtn.hidden = true;
          });
      }

      // Event wiring
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function() {
          fetchPage(state.page + 1, true);
        });
      }

      function resetAndFetch() {
        state.page = 1;
        state.questionOptions.skin_type.clear();
        state.questionOptions.skin_goal.clear();
        fetchPage(1, false);
      }

      var searchTimer;
      if (searchInput) {
        searchInput.addEventListener('input', function() {
          clearTimeout(searchTimer);
          searchTimer = setTimeout(function() {
            state.search = searchInput.value.trim();
            resetAndFetch();
          }, 350);
        });
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', function() {
          state.sort = sortSelect.value;
          resetAndFetch();
        });
      }

      [filterSkinType, filterSkinGoal].forEach(function(sel) {
        if (!sel) return;
        sel.addEventListener('change', function() {
          var key = sel.dataset.nursemReviewsFilter;
          state.filters[key] = sel.value;
          // Client-side filter only — don't refetch; just re-apply
          var cards = Array.from(grid.querySelectorAll('.nursem-reviews__card'));
          // If filters change, easiest is to refetch and re-render since we may need more data
          resetAndFetch();
        });
      });

      // Initial fetch
      fetchPage(1, false);
    }

    document.querySelectorAll('[data-nursem-reviews]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursem-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStickyAtc(root) {
      var productId = root.dataset.productId;
      var bar = root.querySelector('[data-nursem-sticky-bar]');
      var addBtn = root.querySelector('[data-nursem-sticky-add]');
      if (!bar) return;

      // The real product form lives in blocks/nursem-buy-button (a product-form-component).
      // Match by product id so we never grab a recommendation card's quick-add form.
      var formComponent = document.querySelector(
        'product-form-component[data-product-id="' + productId + '"]'
      );
      var productForm = formComponent ? formComponent.querySelector('form') : null;

      // ── ADD button proxies to the real form's own submit button ──
      // Click the main ADD TO CART button rather than calling requestSubmit() on the form.
      // The buy button block syncs the ReCharge plan into the hidden selling_plan input on
      // that button's pointerdown/click, and Horizon's handler builds FormData before the
      // form's own capture listener runs. requestSubmit() skipped the sync, so with
      // Subscribe & Save selected the sticky bar added a one-off at full price.
      var mainSubmit = productForm ? productForm.querySelector('button[type="submit"]') : null;
      if (addBtn && productForm) {
        addBtn.addEventListener('click', function () {
          if (addBtn.disabled) return;
          if (mainSubmit && !mainSubmit.disabled) {
            mainSubmit.click();
          } else if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit();
          } else {
            productForm.submit();
          }
        });
      }

      // ── Price + label follow the selected purchase option ──
      // blocks/nursem-buy-button keeps the form's selling_plan in sync with the
      // ReCharge widget and broadcasts changes; we just render the matching price.
      var priceEl = root.querySelector('[data-nursem-sticky-price]');
      var labelEl = root.querySelector('[data-nursem-sticky-label]');
      var plansEl = root.querySelector('[data-nursem-sticky-plans]');
      var plans = null;
      try { plans = plansEl ? JSON.parse(plansEl.textContent) : null; } catch (e) { plans = null; }

      function applyPlan(id) {
        if (!plans || !priceEl) return;
        var subPrice = id && plans.plans ? plans.plans[String(id)] : null;
        priceEl.textContent = subPrice || plans.onetime;
        if (labelEl) {
          labelEl.textContent = subPrice ? plans.subLabel : plans.oneLabel;
          // Only label the option when the product actually offers a subscription.
          labelEl.hidden = !(plans.hasPlans > 0) || !labelEl.textContent;
        }
      }

      document.addEventListener('nursem:selling-plan-change', function (e) {
        applyPlan(e.detail && e.detail.sellingPlanId);
      });
      // If the buy button already synced before we initialised, catch up now.
      var hiddenPlan = document.querySelector('[data-nursem-selling-plan-input]');
      if (hiddenPlan && hiddenPlan.value) applyPlan(hiddenPlan.value);

      // ── Show the bar once the main buy button scrolls above the viewport ──
      // Observe the main form component; when it sits above the top edge,
      // the shopper has scrolled past the primary ATC and needs the sticky one.
      var observeTarget = formComponent || document.querySelector('.nursem-product-details');
      if (!observeTarget || !('IntersectionObserver' in window)) {
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        },
        { threshold: 0 }
      );

      observer.observe(observeTarget);
    }

    document.querySelectorAll('nursem-sticky-atc').forEach(initStickyAtc);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursem-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel(root) {
      var track = root.querySelector('[data-nursem-ugc-track]');
      var prev = root.querySelector('[data-nursem-ugc-prev]');
      var next = root.querySelector('[data-nursem-ugc-next]');
      if (!track) return;

      function slideWidth() {
        var slide = track.querySelector('.nursem-ugc__slide');
        if (!slide) return 0;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= max;
      }

      if (prev) {
        prev.addEventListener('click', function() {
          track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      // Press-to-play: the centred play button plays the video with sound + controls.
      track.querySelectorAll('.nursem-ugc__play').forEach(function(btn) {
        var slide = btn.closest('.nursem-ugc__slide');
        var video = slide && slide.querySelector('video');
        if (!video) return;
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          // Stop any other video the user has started in this carousel.
          track.querySelectorAll('.nursem-ugc__slide.is-playing').forEach(function(s) {
            if (s !== slide) {
              var ov = s.querySelector('video');
              if (ov) { ov.pause(); ov.controls = false; }
              s.classList.remove('is-playing');
            }
          });
          video.muted = false;
          video.loop = false;
          video.controls = true;
          video.dataset.userPlayed = '1';
          slide.classList.add('is-playing');
          video.play().catch(function() {});
        });
        // Restore the play button once a user-started video finishes.
        video.addEventListener('ended', function() {
          video.controls = false;
          video.currentTime = 0;
          slide.classList.remove('is-playing');
        });
      });

      // Lazy-autoplay videos (muted preview) when they enter the viewport. Pause when out.
      // Skips any video the user has taken control of via the play button.
      if ('IntersectionObserver' in window) {
        var videos = track.querySelectorAll('video[autoplay]');
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            var v = entry.target;
            if (v.dataset.userPlayed) return;
            if (entry.isIntersecting) {
              if (v.paused) v.play().catch(function() {});
            } else {
              if (!v.paused) v.pause();
            }
          });
        }, { threshold: 0.25 });
        videos.forEach(function(v) { io.observe(v); });
      }
    }

    document.querySelectorAll('.nursem-ugc').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nursem-upsell"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.nursem-upsell__form').forEach(function(form) {
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        var button = form.querySelector('.nursem-upsell__button');
        if (!button || button.disabled) return;

        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function() {
            // Sync Horizon cart drawer
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (window.CartUpdateEvent) {
              document.dispatchEvent(new window.CartUpdateEvent({ source: 'nursem-upsell' }));
            }
            // Open the cart drawer if present
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
            } else {
              var cartIcon = document.querySelector('[data-cart-drawer-trigger], .header-actions__cart');
              if (cartIcon) cartIcon.click();
            }
            button.textContent = 'Added ✓';
            setTimeout(function() {
              button.disabled = false;
              button.textContent = originalText;
            }, 1500);
          })
          .catch(function() {
            button.textContent = 'Try again';
            setTimeout(function() {
              button.disabled = false;
              button.textContent = originalText;
            }, 1500);
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
